export default "__VITE_ASSET__D6iyN2p9__"